module.exports = __webpack_public_path__ + "static/media/D5.29237b58.wav";